import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Button } from 'primereact/button';


export interface JustifiedButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  className?: string;
}

export const JustifiedAddButton = (props: JustifiedButtonProps): ReactNode => {
  return (
    <div className={`flex justify-content-end ${props.className ?? ''}`}>
      <AddButton onClick={props.onClick} disabled={props.disabled}/>
    </div>
  );
};

export const JustifiedDeleteButton = (props: JustifiedButtonProps): ReactNode => {
  return (
    <div className={`flex justify-content-end ${props.className ?? ''}`}>
      <DeleteButton onClick={props.onClick} disabled={props.disabled}/>
    </div>
  );
};

export const AddButton: React.FC<PropsWithChildren<{
  onClick: (e: any) => void;
  disabled?: boolean;
  className?: string;
}>> = ({onClick, className, disabled, children}): ReactElement => {
  const intl: IntlShape = useIntl();

  return (
    <Button
      className={`w-2rem ${className}`}
      icon={'pi pi-plus'}
      disabled={disabled}
      tooltip={intl.formatMessage({ id: 'button.add' })}
      tooltipOptions={{ position: 'bottom' }}
      onClick={onClick}
    ></Button>
  );
};

export const DeleteButton: React.FC<PropsWithChildren<{
  onClick: (e: any) => void;
  disabled?: boolean;
  size?: number;
  className?: string;
}>> = ({onClick, className, disabled}): ReactElement => {
  const intl: IntlShape = useIntl();

  return (
    <Button
      className={`w-2rem flex-grow-0 flex-shrink-0 ${className}`}
      icon={'pi pi-trash'}
      disabled={disabled}
      severity={'danger'}
      tooltip={intl.formatMessage({ id: 'button.delete' })}
      tooltipOptions={{ position: 'bottom' }}
      onClick={onClick}
    />
  );
};
